import {ICONS} from '@/constants/icons';

export default {
  updatedAtLabel: 'Aktualizované:',
  breadcrumbs: {
    home: 'Domovská stránka',
  },
  hero: {
    badges: [
      {
        iconName: 'badgeTrustUs',
        description: 'Prečo nám môžete dôverovať',
        details: {
          text: '<h2>Prečo nám môžete dôverovať</h2><p>Články na stránke Natu.Care sú napísané na základe vedeckého výskumu, údajov z vládnych webových stránok a iných spoľahlivých zdrojov. Texty sú písané v spolupráci s lekármi, odborníkmi na výživu a ďalšími odborníkmi na zdravie a krásu. Články sú pred publikovaním a pri významných aktualizáciách kontrolované.</p>',
          footerText: '<p>Viac informácií nájdete v našom <a href="/sk/o-nas/proces-redakcny">redakčnom procese</a>.</p>'
        }
      },
      {
        iconName: 'badgeAdDisclosure',
        description: 'Informácie o reklame',
        details: {
          text: '<h2>Informácie o reklame</h2><p>Obsah na stránke Natu.Care môže obsahovať odkazy na produkty, z ktorých predaja môžeme získať províziu. Pri tvorbe obsahu dodržiavame vysoké redakčné štandardy a dbáme na objektivitu diskutovaných produktov. Prítomnosť partnerských odkazov nie je diktovaná našimi partnermi a produkty, ktoré recenzujeme, si vyberáme sami úplne nezávisle.</p>',
          footerText: '<p>Viac informácií nájdete v našich <a href="/sk/podmienky">podmienkach</a></p>'
        }
      }
    ],
    tooltip: {
      labelVerified: 'Overené odborníkom',
      footerText: '<p>Viac informácií nájdete v našom <a href="/sk/o-nas/proces-redakcny">redakčnom procese</a></p>'
    }
  },

  mediabar: {
    heading: 'Médiá o nás:',
    href: '/sk/o-nas',
    title: 'O nás',
    items: [
      {
        icon: ICONS['vogue'],
        href: 'https://kobieta.wp.pl/toner-do-wlosow-jak-nakladac-6861428991200064a'
      },
      {
        icon: ICONS['wpKobieta'],
        href: 'https://zdrowietvn.pl/a/poznaj-zrodla-kolagenu-i-badz-piekna'
      },
      {
        icon: ICONS['medonet'],
        href: 'https://porady.interia.pl/artykul-sponsorowany/news-poznaj-dzialanie-tonera-do-wlosow,nId,6525474'
      },
      {
        icon: ICONS['zdrowieTvn'],
        href: 'https://zwierciadlo.pl/material-partnera/532112,1,toner-do-wlosow--jak-nakladac.read'
      },
      {
        icon: ICONS['interiaPorady'],
        href: 'https://upacjenta.pl/poradnik/wplyw-witaminy-d3-na-skore'
      },
      {
        icon: ICONS['zwierciadlo'],
        href: 'https://upacjenta.pl/poradnik/wplyw-witaminy-d3-na-skore'
      },
      {
        icon: ICONS['uPacjenta'],
        href: 'https://upacjenta.pl/poradnik/wplyw-witaminy-d3-na-skore'
      }   
    ]
  },

  cta: {
    heading: 'Zabezpečenie zdravého tela',
    description: 'Vyskúšajte vysokokvalitné doplnky stravy Natu.Care',
    button: {label: 'Zobraziť produkty', href: 'https://natu.shop/collections'},
    picture: {alt: 'Mladé, krásne ženy s dobrým stavom pleti.'}
  },

  authorship: {
    heading: 'Redakcia',
    link: {
      label: 'Zoznámte sa s tímom',
      href: '/sk/o-nas/redakcia'
    }
  },

  similarArticles: {
    headingBlogList: 'Články',
    headingBlogPost: 'Podobné články'
  }
};